
function article_1() {
	return {
		date: "June 2023 - Aug 2023",
		title: "CMOTS Internet Technologies Pvt. Ltd. (Internship)",
		description:
			"As part of my internship, I was actively involved in developing an Employee App for the company using MERN stack, showcasing my skills in creating efficient and user-friendly interfaces.",
		link: "https://firebasestorage.googleapis.com/v0/b/internship-faea3.appspot.com/o/CMOTS_Certificate.jpg?alt=media&token=81f6eb57-a9ff-4b13-ac2a-0c1b1035a928",
	};
}

function article_2() {
	return {
		date: "Aug 2021 - Sep 2021",
		title: "SkyFocus Technologies (Internship)",
		description:
			"During my web development internship, I gained hands-on experience working with ASP.NET and had the opportunity to contribute to live projects, enhancing my skills in building dynamic and interactive web applications.",
		link: "https://firebasestorage.googleapis.com/v0/b/internship-faea3.appspot.com/o/Shane_Certificate1.jpg?alt=media&token=5d34f771-3b91-42c9-a007-2dae9821d75e",
	};
}

const myArticles = [article_1, article_2];

export default myArticles;
